import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber10 = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm2.156 3.974c-1.913 0-2.96 1.689-2.96 3.895 0 2.195 1.047 3.895 2.96 3.895 1.914 0 2.961-1.7 2.961-3.895 0-2.207-1.047-3.895-2.96-3.895zm-4.31.012-3.096.731v1.25l1.688-.416v6.078h1.407V3.986zm4.31 1.17c1.103 0 1.565 1.125 1.565 2.713 0 1.587-.462 2.713-1.565 2.713-1.092 0-1.553-1.126-1.553-2.713 0-1.587.461-2.713 1.553-2.713z" />
    </g>
  );
};

export default withIcon(IconNumber10);
